document.addEventListener("DOMContentLoaded", function () {
  // 上传数据逻辑
  var uploadData = localStorage.getItem("uploadData");
  var additionalContentDiv = document.getElementById("additionalContent");
  var contentTitle = document.getElementById("content_title");
  var additionalContentImg = document.getElementById("additionalContentimg");

  if (!uploadData) {
    additionalContentDiv.style.display = "none";
    contentTitle.style.display = "none";
    additionalContentImg.style.display = "none";
  } else {
    additionalContentDiv.style.display = "block";
    contentTitle.style.display = "block";
    additionalContentImg.style.display = "flex";

    var data = JSON.parse(uploadData);
    if (data.filename) {
      var filenameParts = data.filename.split(".");
      var filenameWithoutExt = filenameParts[0];

      // 构建额外内容 DOM
      var customContent = document.createElement("div");
      customContent.className = "t4s-container";
      customContent.innerHTML = `
        <div class="upload-feedback custom-responsive">
          <div class="image-content custom-item">
            <a href="/pages/frame-photos"><img src="https://imageretrun.decorarts.net/uploadsFile/${data.filename}" alt="Uploaded Image"></a>
          </div>
          <div class="text-content custom-item custom-text">
            <h3>Thank you for your upload!</h3>
            <p>Your last uploaded image data:<br/>
              <b><span>Width: </span>${data.width}</b><br/>
              <b><span>Height: </span>${data.height}</b>
            </p>
            <button id="deleteCacheBtn" class="delete-cache-btn">Delete Record</button>
          </div>
        </div>`;
      additionalContentDiv.appendChild(customContent);
      // 删除缓存按钮功能
      document.getElementById("deleteCacheBtn").addEventListener("click", function () {
        localStorage.removeItem("uploadData");
        additionalContentDiv.style.display = "none";
        contentTitle.style.display = "none";
        additionalContentImg.style.display = "none";
        alert("Cache cleared successfully!");
      });
        
      var additionalContent = document.getElementById('additionalContentimg');
      var topContent = document.createElement('content_title');
      topContent.className = 'top-content';
      topContent.innerHTML = `AVAILABLE PRODUCTS`;

      var leftContent = document.createElement('div');
      leftContent.className = 'left-content';
      leftContent.innerHTML = `<a href="/pages/frame-photos"><img src="data:image/gif;base64,R0lGODdhAQABAIEAAPDw8AAAAAAAAAAAACwAAAAAAQABAAAIBAABBAQAOw==" data-src="https://imageretrun.decorarts.net/canvas/20/16/25/${filenameWithoutExt}.jpg" alt="Uploaded Image" class="lazyload" data-lazyload="true"></a>`;

      var centerContentleft = document.createElement('div');
      centerContentleft.className = 'center-content-left';
      centerContentleft.innerHTML = `<a href="/pages/frame-photos"><img src="data:image/gif;base64,R0lGODdhAQABAIEAAPDw8AAAAAAAAAAAACwAAAAAAQABAAAIBAABBAQAOw==" data-src="https://imageretrun.decorarts.net/Scenes/canvas/20/16/${filenameWithoutExt}/Scenes02.jpg" class="lazyload" data-lazyload="true"></a>`;

      var centerContentright = document.createElement('div');
      centerContentright.className = 'center-content-right';
      centerContentright.innerHTML = `<a href="/pages/frame-photos"><img src="data:image/gif;base64,R0lGODdhAQABAIEAAPDw8AAAAAAAAAAAACwAAAAAAQABAAAIBAABBAQAOw==" data-src="https://imageretrun.decorarts.net/Scenes/frame/F97/20/16/0/${filenameWithoutExt}/Scenes03.jpg" class="lazyload" data-lazyload="true"></a>`;

      var rightContent = document.createElement('div');
      rightContent.className = 'right-content';
      rightContent.innerHTML = `<a href="/pages/frame-photos"><img src="data:image/gif;base64,R0lGODdhAQABAIEAAPDw8AAAAAAAAAAAACwAAAAAAQABAAAIBAABBAQAOw==" data-src="https://imageretrun.decorarts.net/frame/F94/20/16/10/${filenameWithoutExt}.jpg" class="lazyload" data-lazyload="true"></h3></a>`;

      additionalContent.appendChild(leftContent);
      additionalContent.appendChild(centerContentleft);
      additionalContent.appendChild(centerContentright);
      additionalContent.appendChild(rightContent);
      content_title.appendChild(topContent);

      const lazyImages = [
        ...customContent.querySelectorAll('.lazyload'),
        ...document.querySelectorAll('.left-content img.lazyload'),
        ...document.querySelectorAll('.center-content-left img.lazyload'),
        ...document.querySelectorAll('.center-content-right img.lazyload'),
        ...document.querySelectorAll('.right-content img.lazyload')
      ];
    
      const lazyLoad = (image) => {
        image.src = image.dataset.src;
        image.classList.remove('lazyload');
      };
        if ('IntersectionObserver' in window) {
      let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            let lazyImage = entry.target;
            lazyLoad(lazyImage);
            lazyImageObserver.unobserve(lazyImage);
          }
        });
      });
      lazyImages.forEach(function (lazyImage) {
        lazyImageObserver.observe(lazyImage);
      });
    } else {
      lazyImages.forEach(function (image) {
        lazyLoad(image);
      });
    }
    }
  }
  // Modal 显示逻辑
  var modal = document.getElementById("myModal");
  var closeBtn = document.getElementsByClassName("close")[0];
  var opens = document.getElementsByClassName("upload-btn")[0];
  closeBtn.onclick = function () {
    modal.style.display = "none";
  };

  opens.onclick = function () {
    modal.style.display = "flex";
  };

  window.onclick = function (event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  };
  
});


document.addEventListener("DOMContentLoaded", function () {
  const uploadBtn = document.getElementById("uploadBtn"); // 获取上传按钮
  const croppedImage = document.getElementById("cropped-image"); // 获取裁剪后的图片
  const addToCartBtn =  document.getElementById("addToCartBtn");
  var variantId = 42526171398322;  // 替换为实际的变体ID
  var quantity = 1;  // 数量


  // addToCartBtn.addEventListener('click', function() {
  //   // 使用 Fetch API 添加变体到购物车
  //   fetch('/cart/add.js', {
  //     method: 'POST',
  //     body: JSON.stringify({
  //       items: [{
  //         id: variantId,  // 变体 ID
  //         quantity: quantity  // 数量
  //       }]
  //     }),
  //     headers: {
  //       'Content-Type': 'application/json'
  //     }
  //   })
  //   .then(response => response.json())
  //   .then(data => {
  //     document.getElementById('cartMessage').textContent = 'Item successfully added to the cart!';
  //     document.getElementById('cartMessage').style.display = 'block';
  //   })
  //   .catch(error => {
  //     document.getElementById('cartMessage').textContent = 'Error adding item to the cart.';
  //     document.getElementById('cartMessage').style.display = 'block';
  //   });
  // });





  // 上传按钮逻辑
  uploadBtn.addEventListener("click", function () {
    if (!croppedImage || !croppedImage.src) {
      alert("Please crop the image before uploading!");
      return;
    }
    // 将裁剪后的图片发送到服务器
    const croppedImgData = croppedImage.src; // 获取裁剪后的图片数据
    const formData = new FormData();
    formData.append("file", dataURLtoBlob(croppedImgData), "cropped-image.png"); // 转换为 Blob
    // 使用 XMLHttpRequest 上传图片
    const xhr = new XMLHttpRequest();
    xhr.open("POST", "https://imageretrun.decorarts.net/uploads", true); // 替换为你的上传接口
    xhr.onload = function () {
      if (xhr.status == 200) {
        var data = JSON.parse(xhr.responseText);
        localStorage.setItem("uploadData", JSON.stringify(data));
        console.log("Success:", data);
        showSuccessModal();
      } else {
        console.error("Error:", xhr.responseText);
      }
    };
    xhr.onerror = function () {
      console.error("Upload failed.");
    };
    xhr.send(formData);
  });

  // 将 Base64 转为 Blob 的辅助函数
  function dataURLtoBlob(dataURL) {
    const parts = dataURL.split(";base64,");
    const contentType = parts[0].split(":")[1];
    const raw = window.atob(parts[1]);
    const rawLength = raw.length;
    const uInt8Array = new Uint8Array(rawLength);
    for (let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
    }
    return new Blob([uInt8Array], { type: contentType });
  }


  function showSuccessModal() {
    // 创建模态框 HTML
    const modalHTML = `
      <div id="success-modal" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.5); display: flex; justify-content: center; align-items: center; z-index: 99999;">
        <div style="background: white; padding: 20px; border-radius: 8px; text-align: center; width: 300px;">
          <h3>Upload successful!</h3>
          <div style="margin-top: 20px; display: flex; justify-content: space-between;">
            <button id="customize-btn" style="flex: 1; margin-right: 5px; padding: 10px; background-color: #007bff; color: white; border: none; border-radius: 4px; cursor: pointer;">Jump to customization</button>
            <button id="refresh-btn" style="flex: 1; margin-left: 5px; padding: 10px; background-color: #28a745; color: white; border: none; border-radius: 4px; cursor: pointer;">Refreshe</button>
          </div>
        </div>
      </div>
    `;

    // 插入到页面中
    document.body.insertAdjacentHTML("beforeend", modalHTML);

    // 为按钮添加事件监听
    document.getElementById("customize-btn").addEventListener("click", function () {
      window.location.href = "/pages/frame-photos"; // 替换为你的定制页面链接
    });

    document.getElementById("refresh-btn").addEventListener("click", function () {
      modal.style.display = "none";
      window.location.reload();
    });
  }



});




document.addEventListener("DOMContentLoaded", function () {
  const imageInput = document.getElementById("image-input");
  const imagePreview = document.getElementById("image-preview");
  const cropContainer = document.getElementById("crop-container");
  const cropButton = document.getElementById("crop-button");
  const resetButton = document.getElementById("reset-button");
  const croppedResult = document.getElementById("cropped-result");
  const croppedImage = document.getElementById("cropped-image");

  let cropper = null;

  // 图片上传监听
  imageInput.addEventListener("change", function (event) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = function (e) {
        imagePreview.src = e.target.result;

        // 初始化 Cropper.js
        if (cropper) {
          cropper.destroy(); // 销毁旧的 cropper 实例
        }
        cropper = new Cropper(imagePreview, {
          viewMode: 2, // 限制裁剪框不能超出图片范围
          autoCropArea: 1, // 默认最大裁剪区域
          movable: true,
          scalable: true,
          zoomable: true,
          background: true,
          cropBoxResizable: true,
        });

        // 显示裁剪容器
        cropContainer.classList.remove("hidden");
        croppedResult.classList.add("hidden");
      };
      reader.readAsDataURL(file);
    }
  });

  // 裁剪按钮逻辑
  cropButton.addEventListener("click", function () {
    if (cropper) {
      croppedResult.classList.remove("hidden");
      const canvas = cropper.getCroppedCanvas({
      });
      const croppedImgData = canvas.toDataURL("image/png");
      croppedImage.src = croppedImgData;
    }
  });

  // 重置按钮逻辑
  resetButton.addEventListener("click", function () {
    if (cropper) {
      cropper.reset();
      croppedResult.classList.add("hidden");
    }
  });
});
